import React from 'react';
import CustomDropdown from '../dropdown/CustomDropDown';
import DropdownItem from 'react-bootstrap/DropdownItem';
import styled from 'styled-components';
import DropDownIcon from '../svgIcons/DropDownIcon';
import { formatPhone, handleErrorImg } from '../../../utils/helper';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectBasicInformation } from '../../../features/auth/authSlice';
import StyledText from './StyledText';
import StyledImage from './StyledImage';
import ProfileIcons from '../svgIcons/ProfileIcons';
import { Card } from 'react-bootstrap';
import StyledHr from './StyledHr';

const StyledProfileDropDown = ({
  toggleClassName,
  menuItems,
  menuClassName,
  profile,
  firstMenu,
}) => {
  const basicInfo = useSelector(selectBasicInformation);
  return (
    <ProfileDropDownStyle className="d-flex align-items-center">
      <CustomDropdown
        dropDownProps={'border-0 ms-0'}
        toggleClassName={`border-0 ${toggleClassName}`}
        menuClassName={`${menuClassName} mt-2 user-dropdown custom-position`}
        dropdownToggle={
          <>
            <div
              className={`account-img  cursor-pointer ${
                !profile?.image ? 'default' : ''
              }`}
            >
              {profile?.image || basicInfo?.imageUrl ? (
                <img
                  loading="lazy"
                  src={profile?.imageUrl || basicInfo?.imageUrl}
                  alt={profile?.firstName || 'image'}
                  onError={handleErrorImg}
                />
              ) : (
                profile?.firstName?.charAt(0).toUpperCase()
              )}
            </div>
            <div className={`account-menu ${toggleClassName} `}>
              {/*<div className={`account-img default`}>*/}
              <StyledText as="h6" color="icon">
                {profile?.firstName || ''}
              </StyledText>
              <DropDownIcon rotate="down" className="ms-2" />
            </div>
          </>
        }
        dropdownMenu={
          <div>
            <div className="d-flex p-2">
              <StyledImage
                size="40px"
                className="mb-0 me-2 text-muted rounded-circle"
              >
                {profile?.image || basicInfo?.imageUrl ? (
                  <img
                    loading="lazy"
                    src={profile?.image || basicInfo?.imageUrl}
                    alt={profile?.firstName || 'image'}
                  />
                ) : (
                  <ProfileIcons />
                )}
              </StyledImage>
              <div className="d-flex flex-column w-75">
                <UserName>
                  {`${profile?.firstName || ''} ${profile?.lastName || ''}`}
                </UserName>
                {profile?.phone && (
                  <StyledText color="primaryDark">
                    {profile?.phone ? formatPhone(profile.phone) : '-'}
                  </StyledText>
                )}
                {profile?.email && (
                  <StyledText color="primaryDark">{profile?.email}</StyledText>
                )}
                {/*{user?.rating && (*/}
                {/*<div className="d-flex align-items-center">*/}
                {/*  <span className="mfs-6">*/}
                {/*    <i*/}
                {/*      className="fa fa-star d-flex align-items-center"*/}
                {/*      aria-hidden="true"*/}
                {/*    />*/}
                {/*  </span>*/}
                {/*  <StyledText className="mb-0 ms-1" $fontSize="14px">*/}
                {/*    {user?.rating || '5.0'}*/}
                {/*    {'  '}*/}
                {/*    {user?.ratedBy ? <>({user?.ratedBy})</> : '(20 Reviews)'}*/}
                {/*  </StyledText>*/}
                {/*</div>*/}
                {/*)}*/}
                {/*<StyledHr />*/}
                {/*{user.address && (*/}
                {/*<div className="d-flex align-items-center  mt-2">*/}
                {/*  <StyledText className="d-flex mb-0" color="primaryDark">*/}
                {/*    <LocationIcon />*/}
                {/*  </StyledText>*/}

                {/*  <Address className="ms-1 d-flex align-items-center">*/}
                {/*    {user?.address || '-'}*/}
                {/*  </Address>*/}
                {/*</div>*/}

                {/*)}*/}
              </div>
              {/*<WhatsApp className="text-muted" />*/}
            </div>
            <StyledHr />
            <span>
              {firstMenu?.map((item, index) => (
                <DropdownItem
                  to={item?.to}
                  as={Link}
                  key={`${index}-${item.to}`}
                >
                  <span className="dark-text">{item.icon}</span>
                  <span className="ms-3">{item?.name}</span>
                </DropdownItem>
              ))}
            </span>
            <StyledHr />
            <span>
              {menuItems?.map((item, index) => (
                <DropdownItem onClick={item?.action} key={index}>
                  <span className="dark-text">{item.icon}</span>
                  <span className="ms-3">{item?.name}</span>
                </DropdownItem>
              ))}
            </span>
          </div>
        }
      />
    </ProfileDropDownStyle>
  );
};
StyledProfileDropDown.defaultProps = {
  toggleClassName: '',
  menuItems: [],
  menuClassName: '',
  profile: {
    firstName: '',
  },
};
const ProfileDropDownStyle = styled.div`
  .user-dropdown {
    width: min(320px, calc(100vw - 125px));
    padding: 0.5rem 0 !important;
    .dropdown-item {
      padding: 0.8rem 1rem 0.7rem 1rem !important;
      font-size: 12px;
      font-weight: 600;

      &:not(:last-child) {
        border: 0;
      }

      &:hover {
        border-radius: 10px;
        color: ${({ theme }) => theme.headingColor} !important;
        background-color: ${({ theme }) => theme.hoverColor} !important;
      }
    }
  }

  .menu-toggle {
    padding-block: 0;
  }

  .account-menu {
    display: flex;
    align-items: center;
    font-family: 'Instrument Sans';
    color: ${({ theme }) => theme.icon};
    h6 {
      font-size: 18px;
      font-weight: 600;
      margin: 0;
      font-family: 'Instrument Sans';
      color: ${({ theme }) => theme.icon};
    }
    @media screen and (max-width: 767px) {
      display: none;
    }
  }

  .account-img {
    width: 48px;
    height: 48px;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 10px;

    &.default {
      background-color: ${({ theme }) => theme.defaultImage};
      border-radius: 50%;
      color: ${({ theme }) => theme.white};
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
`;

const UserName = styled(Card.Title)`
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0px;
  color: ${({ theme }) => theme.primaryDark};
`;
export default StyledProfileDropDown;
